export default "__VITE_ASSET__FmrBhR_4__"